<template>
  <img
    ref="image"
    class="transition-all duration-300 ease-in-out"
    :src="lowDefinition"
    :width="width"
    :height="height"
    :alt="alt"
    :class="{
      'blur-sm': !isLoaded,
      'opacity-0': !isLoadedLowDefinition
    }"
    @load="() => isLoadedLowDefinition=true"
  >
</template>
<script setup>
import { inject, ref } from 'vue';
import { useImage } from '@vueuse/core';

const props = defineProps({
  src: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    required: true,
  },
  height: {
    type: Number,
    required: true,
  },
  alt: {
    type: String,
    default: '',
  },
  factor: {
    type: Number,
    default: 10,
  },
});

const image = ref(null);
const isLoaded = ref(false);
const isLoadedLowDefinition = ref(false);

const baseUrl = `${inject('imageProxyUrl')}rs:auto:`;
const endUrl = `:0/plain/${props.src}`;
const source = `${baseUrl}${props.width}:${props.height}${endUrl}`;
const lowDefinition = `${baseUrl}${~~(props.width / props.factor)}:${~~(props.height / props.factor)}${endUrl}`;

const { then } = useImage({ src: source });

then(() => (isLoaded.value = true) && (image.value.src = source), () => image.value.src = inject('logo'));

</script>
